// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TQlP","colMin":"styles_colMin__38rz3"};